import { useState } from "react";
import { Navigate } from "react-router-dom";
import { OtpGate } from "@/components/OtpGate";
import { copy } from "@/lib/copy";

/**
 * La PORTE de l'espace, et rien de plus.
 *
 * L'entreprise saisit l'email avec lequel elle a déposé, reçoit un code, et entre.
 * Elle ne voit plus la liste ici : cet écran ne sait rien afficher de mieux que
 * l'espace lui-même, et deux endroits qui montrent les mêmes demandes finissent
 * toujours par diverger.
 *
 * Pas de mot de passe, et on ne le dit pas : on ne rassure pas en niant un problème
 * que personne ne s'était posé.
 *
 * La mécanique (les deux étapes, les erreurs, la session encore ouverte) vit dans
 * `OtpGate` : l'espace école a exactement la même porte.
 */
export function MyRequestsPage() {
	const [ouvert, setOuvert] = useState(false);
	if (ouvert) return <Navigate to="/espace" replace />;

	return (
		<OtpGate
			texts={{
				eyebrow: copy.tracking.eyebrow,
				title: copy.tracking.title,
				emailLabel: copy.tracking.emailLabel,
				emailHelp: copy.tracking.emailHelp,
				emailPlaceholder: copy.tracking.emailPlaceholder,
				askCode: copy.tracking.askCode,
				enter: copy.tracking.openList,
			}}
			probePath="/api/espace"
			requestPath="/api/requests/access/request"
			verifyPath="/api/requests/access/verify"
			onOpen={() => setOuvert(true)}
		/>
	);
}
